// login.js

import {
  getService,
  postService
} from '../api/service.js'
/**
 * name 登录
 * time 2021-09-07
 * param userName String 账号
 * param password String 密码
 * return String token
 * */
// 列表数据
export const scenicPost = params => {
  return postService('/api/jfy/getScenicList', params)
}
// 上下线
export const statusPost = params => {
  return postService('/api/jfy/updateScenicStatus', params)
}

// 景区详情
export const ScenicInfoPost = params => {
  return postService('/api/jfy/getScenicInfo', params)
}
// 景区修改
export const updateScenicPost = params => {
  return postService('/api/jfy/updateScenic', params)
}
// 景区添加
export const addScenicPost = params => {
  return postService('/api/jfy/addScenic', params)
}
// 充值记录
export const getScenicPayListPost = params => {
  return postService('/api/jfy/getScenicPayList', params)
}
// 充值管理
export const scenicPayPost = params => {
  return postService('/api/jfy/scenicPay', params)
}
// 景区修改密码
export const adminScenicPwdUpdatePost = params => {
  return postService('/api/jfy/adminScenicPwdUpdate', params)
}
// 景区授权分销商列表
export const getScenicDistributorListPost = params => {
  return postService('/api/jfy/getScenicDistributorList', params)
}
// 景区授权分销商
export const scenicImpowerDistributorPost = params => {
  return postService('/api/jfy/scenicImpowerDistributor', params)
}
// 景区取消授权一级分销商
export const scenicCancelImpowerDistributorPost = params => {
  return postService('/api/jfy/scenicCancelImpowerDistributor', params)
}

/**
 * name 登出
 * time 2021-09-07
 * */
export const proviceGet = params => {
  return getService('/v3/config/district?parameters', params)
}
// 景区余额提醒列表
export const SmsList = params =>{ 
  return postService('api/jfy/SmsList', params)
}
// 短信审核列表
export const smsVerifyList = params =>{ 
  return postService('api/jfy/smsVerifyList', params)
}
// 短信审核
export const smsVerify = params =>{ 
  return postService('api/jfy/smsVerify', params)
}
// 短信审核详情
export const smsDetail = params =>{ 
  return postService('api/jfy/smsDetail', params)
}
// 短信审核详情
export const updateQfAccount = params =>{ 
  return postService('api/jfy/updateQfAccount', params)
}


// 景区免登录
export const jfyScenicLogin = params => {
  return postService('api/jfy/jfyScenicLogin', params)
}

// 订单短信模板列表
export const list_sms = params => {
  return postService('api/jfy/list_sms', params)
}
// 订单短信模板详情
export const Info_sms = params => {
  return postService('api/jfy/Info_sms', params)
}
// 短信模板审核
export const checkSms = params => {
  return postService('api/jfy/checkSms', params)
}


// 退款短信模板列表
export const refundSmsTemplate = params => {
  return postService('api/jfy/refundSmsTemplate', params)
}
// 退款短信模板详情
export const refundSmsTemplateInfo = params => {
  return postService('api/jfy/refundSmsTemplateInfo', params)
}
//退款短信模板审核
export const refundSmsTemplateCheck = params => {
  return postService('api/jfy/refundSmsTemplateCheck', params)
}

//权限列表
export const scenicPermissionList = params => {
  return postService('api/jfy/scenicPermissionList', params)
}

//景区超管权限授权
export const impowerScenicPermission = params => {
  return postService('api/jfy/impowerScenicPermission', params)
}
//景区信息Excel导出
export const exportScenicExcel = params => {
  return postService('api/jfy/exportScenicExcel', params)
}
//景区信息导入
export const addScenicExcel = params => {
  return postService('api/jfy/addScenicExcel', params)
}


